/**
 * useDispatch, useSelector 사용 시 중복 타입 정의를 줄이는 등 효율적인 작업을 위해 hook으로 생성함
 * https://redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
 */

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '@store/store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
